import BatchForm from "../../components/BatchForm/BatchForm";
const AddNewBatch = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <BatchForm type="Add" />
        </div>
    )
}
export default AddNewBatch;